import React from "react";
import { withStyles } from "@material-ui/core";
import Tooltip from "../../../../common/StyledToolTip";
import { ToggleRenderer } from '@dataGrid/components/cellRenderer';
import { getToggleText } from "./utils";

const styles = theme => ({
  toggleAnimationButton: {
    float: "right",
    display: 'flex',
    alignItems: 'center',
  },
  toggleText: {
    display: "inline-block",
    fontSize: "12px",
    color: theme.iconColor
  },
});

const ToggleAnchorPoints = (props) => {
  const {
    classes,
    isOnClickDisabled = false,
    isEnableAnchorPointsInProgress,
    selectedAnchorPoints,
  } = props;
  
  const toggleText = getToggleText(selectedAnchorPoints, props.isEnabled);
  
  return (
    <Tooltip title={props.title}>
      <span className={`${classes.toggleAnimationButton} `}>
        <span className={classes.toggleText}>
          {toggleText}
        </span>
        <ToggleRenderer
          value={props.isEnabled}
          onChange={() => props.onClick && props.onClick()}
          context={{
            disabled: isOnClickDisabled || isEnableAnchorPointsInProgress,
          }}
        />
      </span>
    </Tooltip>
  );
};

export default withStyles(styles)(ToggleAnchorPoints);
